// Tokens sourced from Figma: https://www.figma.com/design/4d2WVe8JUXkq9u8KzaujOY/CR-Manage-R1?node-id=5540-415757&m=dev
import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const alertBoardConfigTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      modal: {
        backgroundColor: theme.color.surface[0],
      },
      header: {
        backgroundColor: theme.color.surface[0],
        borderColor: theme.color.surface[3],
        textColor: theme.color.text.core['-primary'],
      },
      footer: {
        backgroundColor: theme.color.surface[0],
        borderColor: theme.color.surface[3],
      },
      form: {
        backgroundColor: theme.color.surface[0],
        labelColor: theme.color.text.core['-secondary'],
        inputBackgroundColor: theme.color.surface[1],
        inputBorderColor: theme.color.surface[3],
        inputBorderFocusColor: theme.color.focus[1],
        inputTextColor: theme.color.text.core['-primary'],
        placeholderColor: theme.color.text.core['-tertiary'],
        errorColor: theme.color.dataVis.alert['limit-2'],
        dividerColor: theme.color.surface[3],
        sectionTitleColor: theme.color.text.core['-primary'],
        accordionHoverColor: theme.color.surface[1],
        accordionIconColor: theme.color.text.core['-secondary'],
      },
    },
  ]),
);
